import React, { PropTypes } from 'react';
import classNames from 'classnames';

const propTypes = {
  name: PropTypes.string.isRequired, // Icon name
  className: PropTypes.string, // Any additional classes
  size: PropTypes.oneOf(
    // Icon size
    ['lg', '2x', '3x', '4x', '5x']
  ),
  rotate: PropTypes.oneOf(
    // Icon rotation
    ['45', '90', '135', '180', '225', '270', '315']
  ),
  flip: PropTypes.oneOf(
    // Icon flip
    ['horizontal', 'vertical']
  ),
  fixedWidth: PropTypes.bool, // Fixed size icon container
  spin: PropTypes.bool, // Spin
  pulse: PropTypes.bool, // Pulse
  stack: PropTypes.oneOf(['1x', '2x']), // Icon stacking
  inverse: PropTypes.bool, // Inverse colors
  onClick: PropTypes.func,
  style: PropTypes.object
};

const Icon = (
  {
    name,
    size,
    rotate,
    flip,
    spin,
    fixedWidth,
    stack,
    inverse,
    pulse,
    className,
    style,
    onClick
  }
) => {
  const iconName = `fa-${name}`;

  let sizeClass;
  let rotateClass;
  let flipClass;
  let stackClass;

  if (size) sizeClass = `fa-${size}`;
  if (rotate) rotateClass = `fa-rotate-${rotate}`;
  if (flip) flipClass = `fa-flip-${flip}`;
  if (stack) stackClass = `fa-stack-${stack}`;

  return (
    <span
      onClick={onClick || null}
      style={style}
      className={classNames(
        'fa',
        iconName,
        { 'fa-fw': fixedWidth },
        { 'fa-spin': spin },
        { 'fa-pulse': pulse },
        { 'fa-inverse': inverse },
        sizeClass,
        rotateClass,
        flipClass,
        stackClass,
        className
      )}
    />
  );
};

Icon.propTypes = propTypes;

export default Icon;



// WEBPACK FOOTER //
// ./src/components/ui/Icon.js